module.exports = __webpack_public_path__ + "media/images/icon-company-e0f1a5a0c340638a1e1098d49af4fecf.svg";